import React, { createContext, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";
import "./RightDrawer.css";

const DrawerContext = createContext({ close: () => {} });

export function RightDrawer({
  isOpen,
  toggle,
  onClose,
  children,
  className = "",
  size = "md",
}) {
  const close = () => (toggle || onClose)?.();

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") close();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <DrawerContext.Provider value={{ close }}>
      <div className={`right-drawer-root ${className}`}>
        <button type="button" className="right-drawer-backdrop" aria-label="Close panel" onClick={close} />
        <aside
          className={`right-drawer-panel right-drawer-${size}`}
          role="dialog"
          aria-modal="true"
        >
          {children}
        </aside>
      </div>
    </DrawerContext.Provider>,
    document.body,
  );
}

export function ModalHeader({ children, toggle, className = "", close, kicker = "Workspace" }) {
  const { close: contextClose } = useContext(DrawerContext);
  const handleClose = toggle || close?.props?.onClick || contextClose;

  return (
    <div className={`right-drawer-header ${className}`}>
      <div className="right-drawer-title-wrap">
        {kicker ? <span className="right-drawer-kicker">{kicker}</span> : null}
        <h2 className="right-drawer-title">{children}</h2>
      </div>
      <button type="button" className="right-drawer-close" onClick={handleClose} aria-label="Close">
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
}

export function ModalBody({ children, className = "" }) {
  return <div className={`right-drawer-body ${className}`}>{children}</div>;
}

export function ModalFooter({ children, className = "" }) {
  return <div className={`right-drawer-footer ${className}`}>{children}</div>;
}

export const Modal = RightDrawer;

export default RightDrawer;
